import { useCallback, ReactElement } from "react";
import { RootState } from "@/lib/redux/types";
import { LabelledField } from "@/lib/components/LabelledField";
import { LabelText } from "@/lib/components/LabelText";
import { useAppDispatch, useAppSelector } from "@/lib/hooks/redux";
import { setStartDate } from "@/lib/redux/actions";
import { formatISO } from "date-fns";
import { format } from "@/lib/config/localizedDateFns";

export function StartDateField({
  labelText,
  startDates,
}: {
  labelText: string;
  startDates: Date[];
}): ReactElement {
  const value = useAppSelector((state: RootState) => state.startDate);
  const dispatch = useAppDispatch();

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLSelectElement>) => {
      dispatch(setStartDate(event.target.value));
    },
    [dispatch]
  );

  return (
    <LabelledField id="startDate">
      <LabelText requiredIndicator>{labelText}</LabelText>
      <select
        className="select-css"
        value={value || ""}
        onChange={handleChange}
        aria-required
      >
        {startDates.map((startDate) => {
          const iso = formatISO(startDate, { representation: "date" });
          return (
            <option key={iso} value={iso}>
              {format(startDate)}
            </option>
          );
        })}
      </select>
    </LabelledField>
  );
}
